const previewBorderColor = { color: '#00ff00', width: { web: '2px' }, alpha: 1 };
export default {
    previewBorderColor,
};
